var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rose" },
    [
      _vm.showTitle === true
        ? _c(
            "div",
            {
              staticClass:
                "titolo navy--text text--lighten-2 font-hemi-head pb-4 d-flex align-center",
            },
            [_c("div", { staticClass: "mr-2" }, [_vm._v("Rose")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTitle
        ? _c(
            "div",
            { staticClass: "d-flex justify-center pb-4" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "navy--text text--lighten-4",
                  attrs: { small: "", outlined: "", rounded: "" },
                  on: { click: _vm.showDialogRoseLega },
                },
                [_vm._v("Rose")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-slide-group",
        {
          staticClass: "slider",
          attrs: {
            "center-active": "",
            "show-arrows": "",
            mandatory: "",
            "prev-icon": "keyboard_arrow_left",
            "next-icon": "keyboard_arrow_right",
          },
          model: {
            value: _vm.squadra_slider,
            callback: function ($$v) {
              _vm.squadra_slider = $$v
            },
            expression: "squadra_slider",
          },
        },
        _vm._l(_vm.asta_squadre, function (squadra, id) {
          return _c("v-slide-item", {
            key: id,
            attrs: { value: squadra.id },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var active = ref.active
                    var toggle = ref.toggle
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "slider-squadra",
                          attrs: { "input-value": active },
                          on: { click: toggle },
                        },
                        [
                          _c("squadra-crediti", {
                            attrs: { small: "", id: squadra.id },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.asta_squadre, function (squadra, id_squadra) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: id_squadra == _vm.selected_squadra,
                expression: "id_squadra == selected_squadra",
              },
            ],
            key: id_squadra,
            staticClass: "rose-squadra-content",
          },
          [
            _c(
              "div",
              { staticClass: "crediti-squadra" },
              [
                _c("crediti", {
                  attrs: { crediti: _vm.crediti(id_squadra), "use-icon": "" },
                }),
                _vm._v(" "),
                _vm.Config.STANDALONE
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          "x-small": "",
                          depressed: "",
                          color: "navy darken-2",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.promptEditCreditiSquadra(id_squadra)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mode_edit"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("asta-rosa", { attrs: { id_squadra: id_squadra } }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }